<template>
    <div>
        <div
            v-for="(weight, index) in activeFontWeights"
            :key="index"
            @click="setTextVariable(weight)"
            class="fontOptions__item"
        >
            {{ weight.name }}
        </div> 
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        methods: {
            setTextVariable(variable) {
                let payload = {
                    variableName: 'weight',
                    value: variable
                }
                this.$store.dispatch('SET_TEXT_VARIABLE', payload)
            }
        },
        computed: {
            ...mapState([
                'fonts',
            ]),
            ...mapGetters([
                'activeElement',
                'getActiveElement'
            ]),
            activeFontWeights() {
                return (Object.keys(this.getActiveElement).length === 0) ? null : this.fonts.find(font => font.family === this.getActiveElement.font.family).weights;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fontOptions__item {
        cursor: pointer;
        margin: 5px 0;
    }
</style>